import styled, { css } from 'styled-components';

interface ContentProps {
  isFocused: boolean;
  isErrored: boolean;
}

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  strong {
    color: ${({ theme }) => theme.colors.graySecondary};
  }
`;

export const Content = styled.div<ContentProps>`
  display: flex;
  align-items: center;
  height: 100%;
  background: #fff;
  border-radius: 6px;
  padding: 12px 16px;
  width: 100%;
  border: 2px solid ${({ theme }) => theme.colors.graySecondaryLight};

  ${({ isErrored }) =>
    isErrored &&
    css`
      border-color: ${({ theme }) => theme.colors.danger};
    `}

  ${({ isFocused, theme }) =>
    isFocused &&
    css`
      border-color: ${theme.colors.primary};
    `}

  textarea {
    flex: 1;
    height: 100%;
    border: 0;
    background: transparent;
    color: ${({ theme }) => theme.colors.graySecondaryDark};
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    line-height: 14px;

    &:focus {
      box-shadow: 0 0 0 0;
      border: 0 none;
      outline: 0;
    }
  }
`;
